import * as React from "react";

import './TextArea.scss';

export const TextArea = ({ placeholder, type = 'default-input' }) => {
    return (
        <div className={`field ${type}`}>
            <textarea className="input__textarea" placeholder={placeholder}/>
            <label htmlFor="textarea">Textarea</label>
        </div>
    )
};
